import { lazy, Suspense } from "react";
import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import { useAuth } from "./auth";
import { BrandMark } from "./components/Brand";
import { AppShell } from "./components/AppShell";
import { AppToaster } from "./components/ui";
import { LoginPage } from "./pages/LoginPage";
import { MobileAuthChallengePage } from "./pages/MobileAuthChallengePage";

const DashboardPage = lazy(() =>
  import("./pages/DashboardPage").then((module) => ({ default: module.DashboardPage }))
);
const LegalPage = lazy(() =>
  import("./pages/LegalPage").then((module) => ({ default: module.LegalPage }))
);
const SavedPage = lazy(() =>
  import("./pages/SavedPage").then((module) => ({ default: module.SavedPage }))
);
const ResultsPage = lazy(() =>
  import("./pages/ResultsPage").then((module) => ({ default: module.ResultsPage }))
);
const SettingsPage = lazy(() =>
  import("./pages/SettingsPage").then((module) => ({ default: module.SettingsPage }))
);

function PageFallback() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4">
      <span className="flex size-14 items-center justify-center rounded-[1.25rem] border border-primary/15 bg-primary/10">
        <BrandMark size={36} />
      </span>
      <div className="h-1 w-24 overflow-hidden rounded-full bg-muted" aria-label="Đang tải">
        <div className="metric-bar h-full w-2/3 rounded-full bg-primary" />
      </div>
    </div>
  );
}

function ProtectedLayout() {
  const { session, loading } = useAuth();
  if (loading) {
    return (
      <div className="flex min-h-screen flex-col items-center justify-center gap-4">
        <span className="flex size-14 items-center justify-center rounded-[1.25rem] border border-primary/15 bg-primary/10">
          <BrandMark size={36} />
        </span>
        <div className="h-1 w-24 overflow-hidden rounded-full bg-muted" aria-label="Đang tải">
          <div className="metric-bar h-full w-2/3 rounded-full bg-primary" />
        </div>
      </div>
    );
  }
  if (!session) return <Navigate to="/" replace />;
  return (
    <AppShell>
      <Outlet />
    </AppShell>
  );
}

export function App() {
  return (
    <>
      <AppToaster />
      <Suspense fallback={<PageFallback />}>
        <Routes>
          <Route path="/" element={<LoginPage />} />
          <Route path="/mobile-auth/challenge" element={<MobileAuthChallengePage />} />
          <Route path="/terms" element={<LegalPage page="terms" />} />
          <Route path="/privacy" element={<LegalPage page="privacy" />} />
          <Route path="/responsible-play" element={<LegalPage page="responsible" />} />
          <Route element={<ProtectedLayout />}>
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/results" element={<ResultsPage />} />
            <Route path="/saved" element={<SavedPage />} />
            <Route path="/settings" element={<SettingsPage />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Suspense>
    </>
  );
}
